import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddcfd274"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overflow-auto display-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Scenario History")
], -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "details" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "pts", -1))
const _hoisted_9 = { class: "icon" }

import {
  formatTimestamp_DD_MM_YY_SLASHES,
  secondsToMinutesObject
} from '../../utils/utils';
import IconComponent from '../icon/IconComponent.vue';

import Icon from '@/components/icon/Icon';
import { ScenarioDeserializedThing } from '../../ecs/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScenarioHistoryComponent',
  props: {
    scenarios: null,
    selectedItem: null
  },
  emits: ["itemClick"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'itemClick', arg1: ScenarioDeserializedThing): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  scenarios: ScenarioDeserializedThing[];
  selectedItem: ScenarioDeserializedThing;
}





const getIcon = (item: ScenarioDeserializedThing) => {
  if (!item) {
    return Icon.FOLDER_DARK;
  }
  if (item.id === props.selectedItem.id) {
    return Icon.FOLDER_LIGHT;
  }
  return Icon.FOLDER_DARK;
};

const handleItemClick = (item: ScenarioDeserializedThing) => {
  emits('itemClick', item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scenarios, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["list-item", { selected: item.id === __props.selectedItem.id }]),
          onClick: ($event: any) => (handleItemClick(item)),
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formatTimestamp_DD_MM_YY_SLASHES)(item.completedAt)), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["detail", { selected: item.id === __props.selectedItem.id }])
            }, [
              _createElementVNode("div", null, _toDisplayString(_unref(secondsToMinutesObject)(item.history.timeSpent / 1000).minutes) + ":" + _toDisplayString(_unref(secondsToMinutesObject)(item.history.timeSpent / 1000).seconds), 1),
              _hoisted_7,
              _createElementVNode("div", null, _toDisplayString(item.history.pointsEarned), 1),
              _hoisted_8
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(IconComponent, {
              icon: getIcon(item),
              class: "w-10 h-10"
            }, null, 8, ["icon"])
          ])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})